import { FETCH_VIDEOS } from './constants'
import { CLEAR_CONTENT } from '../App/constants'

const initialState = {
  isFetching: false,
  videos: [],
  currentPhoneId: ''
}

export default function videosReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_VIDEOS.REQUEST: {
      return {
        ...state,
        isFetching: true,
        videos: []
      }
    }
    case FETCH_VIDEOS.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        videos: action.videos,
        currentPhoneId: action.currentPhoneId
      }
    }
    case CLEAR_CONTENT: {
      return {
        ...state,
        tutorials: []
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/Videos/reducer.js